import {
    faShieldAlt, faClipboardList, faFlag, faFileSignature, faUserShield,
    faUserSecret, faExclamationTriangle, faCalendarTimes, faHandshake, faFileContract,
} from '@fortawesome/free-solid-svg-icons';

export const COMPLIANCE_NAV = [
    { to: '/compliance', label: 'Compliance Posture', icon: faShieldAlt, end: true },
    { to: '/compliance/audit-log', label: 'Continuous Audit Log', icon: faClipboardList },
    { to: '/compliance/violations', label: 'Violation Flags', icon: faFlag },
    { to: '/compliance/consents', label: 'Consent Registry', icon: faFileSignature },
    { to: '/compliance/access-reviews', label: 'Access Reviews', icon: faUserShield },
    { to: '/compliance/data-subject-requests', label: 'Data Subject Requests', icon: faUserSecret },
    { to: '/compliance/breaches', label: 'Breach Register', icon: faExclamationTriangle },
    { to: '/compliance/retention', label: 'Retention Schedules', icon: faCalendarTimes },
    { to: '/compliance/vendors', label: 'Vendor / BAA Register', icon: faHandshake },
    { to: '/compliance/policies', label: 'Policies & Attestation', icon: faFileContract },
];

export const SEVERITY_COLORS: Record<string, string> = {
    low: 'secondary', medium: 'info', high: 'warning', critical: 'danger',
};

export const RULE_STATUS_META: Record<string, { label: string; color: string }> = {
    pass: { label: 'Pass', color: 'success' },
    fail: { label: 'Fail', color: 'danger' },
    not_assessable: { label: 'Not assessable', color: 'secondary' },
};
